var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_4437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84012 1.84H0.870117V15.78H14.5101V6.51",
    stroke: "#324340",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7001 0.770001C16.1001 1.17 16.1001 1.82 15.7001 2.22L8.29009 9.63H7.32009C7.06009 9.63 6.84009 9.41 6.84009 9.15V8.18L14.2501 0.770001C14.6501 0.370001 15.3001 0.370001 15.7001 0.770001Z",
    fill: "#324340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_4437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.88,
    height: 16.06,
    fill: "white",
    transform: "translate(0.120117 0.470001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8a436d77b591f49cc1f86650f5011d59.svg";
export { ForwardRef as ReactComponent };